import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SharedModule } from 'src/app/shared/shared.module';
import { PricingModule } from '../pricing/pricing.module';
import { SellerCreateOpportunityFormComponent } from './components/seller-create-opportunity/step1/seller-create-opportunity-form/seller-create-opportunity-form.component';
import { ProductDetailPageRoutingModule } from './product-detail-routing.module';
import { ProductDetailPage } from './product-detail.page';
// eslint-disable-next-line max-len
import { ProductDetailAdditionalInfoComponent } from './components/product-detail-additional-info/product-detail-additional-info.component';
import { ProductDetailDescriptionComponent } from './components/product-detail-description/product-detail-description.component';
import { ProductDetailDownloadsComponent } from './components/product-detail-downloads/product-detail-downloads.component';
import { ProductDetailRelatedProductsComponent } from './components/product-detail-related-products/product-detail-related-products.component';
import { ProductDetailShippingInfoComponent } from './components/product-detail-shipping-info/product-detail-shipping-info.component';
import { ProductDetailStatusComponent } from './components/product-detail-status/product-detail-status.component';
import { ProductMessageBannerComponent } from './components/product-message-banner/product-message-banner.component';
import { ProductAlternativeComponent } from './components/product-replacement/product-alternative.component';
import { SellerDetailDescriptionComponent } from './components/seller-detail-description/seller-detail-description.component';
import { SellerDetailMoreInformationComponent } from './components/seller-detail-more-information/seller-detail-more-information.component';
// eslint-disable-next-line max-len
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { SharedProductModule } from '@app/shared-product/shared-product.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ProductDetailCarouselComponent } from '@product-detail/components/product-detail-carousel/product-detail-carousel.component';
import { ProductDetailNotFoundComponent } from '@product-detail/components/product-detail-not-found/product-detail-not-found.component';
import { ProductDetailReportDiscrepanciesComponent } from '@product-detail/components/product-detail-report-discrepancies/product-detail-report-discrepancies.component';
import { SellerDetailCarouselVideosComponent } from '@product-detail/components/seller-detail-carousel-videos/seller-detail-carousel-videos.component';
import { ProductDetailStatusTagsInfoComponent } from '../shared/components/product-detail-status-tags-info/product-detail-status-tags-info.component';
import { UsfProductQuickViewWarningComponent } from '../shared/components/usf-product-quick-view-warning/usf-product-quick-view-warning.component';
import { UsfProductQuickViewInfoComponent } from '../shared/components/usf-product-quick-view/usf-product-quick-view-info/usf-product-quick-view-info.component';
import { UsfProductQuickViewComponent } from '../shared/components/usf-product-quick-view/usf-product-quick-view.component';
import { CustomPricingRationaleComponent } from './components/custom-pricing-rationale/custom-pricing-rationale.component';
import { PowerReviewsDetailsComponent } from './components/power-reviews/power-reviews-details/power-reviews-details.component';
import { PowerReviewsSnippetComponent } from './components/power-reviews/power-reviews-snippet/power-reviews-snippet.component';
import { PwrProductDetailsQuestionsComponent } from './components/power-reviews/pwr-product-details-questions/pwr-product-details-questions.component';
import { ProductDetailDisclaimerComponent } from './components/product-detail-disclaimer/product-detail-disclaimer.component';
import { ProductDetailModalComponent } from './components/product-detail-modal/product-detail-modal.component';
import { ProductDetailModeToggleComponent } from './components/product-detail-mode-toggle/product-detail-mode-toggle.component';
import { ProductDetailNutritionalInfoComponent } from './components/product-detail-nutritional-info/product-detail-nutritional-info.component';
import { ProductDetailSellerImageComponent } from './components/product-detail-seller-image/product-detail-seller-image.component';
import { ProductDetailSummarySellerOverviewComponent } from './components/product-detail-summary-seller-overview/product-detail-summary-seller-overview.component';
import { ProductDetailSummaryComponent } from './components/product-detail-summary/product-detail-summary.component';
import { ProductDetailToastComponent } from './components/product-detail-toast/product-detail-toast.component';
import { SellerCreateOpportunityComponent } from './components/seller-create-opportunity/seller-create-opportunity.component';
import { SellerCreateOpportunityForm2Component } from './components/seller-create-opportunity/step2/seller-create-opportunity-form-2/seller-create-opportunity-form2.component';
import { TitleDropdownComponent } from './components/seller-create-opportunity/step2/seller-create-opportunity-form-2/title-dropdown/title-dropdown.component';
import { SellerDetailDecriptionUpcomingComponent } from './components/seller-detail-description/seller-detail-decription-upcoming/seller-detail-decription-upcoming.component';
import { SellerDetailDescriptionInventoryComponent } from './components/seller-detail-description/seller-detail-description-inventory/seller-detail-description-inventory.component';
import { SellerDetailDescriptionPricingComponent } from './components/seller-detail-description/seller-detail-description-pricing/seller-detail-description-pricing.component';
import { SellerDetailMoreInformationLastFourBuysComponent } from './components/seller-detail-more-information-last-four-buys/seller-detail-more-information-last-four-buys.component';
import { ProductDetailViewerComponent } from './components/product-detail-viewer/product-detail-viewer.component';
import { ProductInventoryInfoComponent } from './components/product-inventory-info/product-inventory-info.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ProductDetailPageRoutingModule,
    TranslateModule,
    MatDatepickerModule,
    IonicModule,
    MatRadioModule,
    SharedProductModule,
    PricingModule,
  ],
  declarations: [
    ProductDetailPage,
    ProductDetailShippingInfoComponent,
    ProductDetailRelatedProductsComponent,
    ProductDetailDescriptionComponent,
    ProductDetailAdditionalInfoComponent,
    ProductDetailStatusComponent,
    ProductAlternativeComponent,
    ProductDetailNutritionalInfoComponent,
    ProductDetailReportDiscrepanciesComponent,
    ProductDetailDisclaimerComponent,
    ProductDetailCarouselComponent,
    // Seller Components
    SellerDetailMoreInformationComponent,
    SellerDetailMoreInformationLastFourBuysComponent,
    SellerDetailDescriptionComponent,
    SellerDetailDescriptionInventoryComponent,
    SellerDetailDecriptionUpcomingComponent,
    SellerDetailDescriptionPricingComponent,
    SellerCreateOpportunityComponent,
    SellerCreateOpportunityFormComponent,
    SellerCreateOpportunityForm2Component,
    CustomPricingRationaleComponent,
    SellerDetailCarouselVideosComponent,
    // Common Components
    ProductDetailDownloadsComponent,
    ProductDetailToastComponent,
    ProductDetailSummaryComponent,
    ProductMessageBannerComponent,
    ProductDetailStatusTagsInfoComponent,
    ProductDetailSellerImageComponent,
    ProductDetailSummarySellerOverviewComponent,
    ProductDetailModeToggleComponent,
    ProductDetailModalComponent,
    UsfProductQuickViewComponent,
    UsfProductQuickViewInfoComponent,
    UsfProductQuickViewWarningComponent,
    ProductDetailViewerComponent,
    ProductInventoryInfoComponent,
    // power reviews
    PowerReviewsDetailsComponent,
    PwrProductDetailsQuestionsComponent,
    PowerReviewsSnippetComponent,
    TitleDropdownComponent,
    ProductDetailNotFoundComponent,
  ],
  exports: [ProductDetailModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductDetailPageModule {}
